"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchSimilarHotelsUI = exports.getSimilarHotels = exports.getSelectedHotels = void 0;
var _ramda = require("ramda");
var _selectors = require("../../../../../../../bus/ui/selectors");
var _constants = require("./constants");
var domain = function domain(_) {
  return _.offerDetails.similarHotels;
};
var getSimilarHotels = exports.getSimilarHotels = (0, _ramda.pipe)(domain, (0, _ramda.prop)('similarHotels'));
var getSelectedHotels = exports.getSelectedHotels = (0, _ramda.pipe)(domain, (0, _ramda.prop)('selectedHotels'));
var searchSimilarHotelsUI = exports.searchSimilarHotelsUI = (0, _ramda.partialRight)(_selectors.getUI, [{
  key: _constants.SEARCH_SIMILAR_HOTELS_UI
}]);